import {
    Icon,
    jnjError,
    jnjCheckCircle,
    jnjWarning,
    jnjInfo,
} from "@jmc/solid-design-system/src/components/atoms/Icon/Icon";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import classnames from "classnames";
import React from "react";
import { mdiClose } from "@mdi/js";
import style from "./style.module.scss";
import { BannerButton } from "@jmc/solid-design-system/src/components/atoms/Banner/BannerButton/BannerButton";

type BannerType = "success" | "warning" | "error" | "info" | "preface";
type IconType = jnjError | jnjCheckCircle | jnjWarning | jnjInfo;
interface PropTypes {
    id?: string;
    text: string | JSX.Element;
    type?: BannerType;
    showIcon?: boolean;
    dismissText?: string;
    dismissIcon?: string;
    onDismiss?: () => void;
    actionBtnText?: string;
    onActionBtnClick?: () => void;
}

const mapping: Record<string, { color: string; icon: IconType }> = {
    success: { color: "success", icon: jnjCheckCircle },
    warning: { color: null, icon: jnjWarning },
    error: { color: "error", icon: jnjError },
    info: { color: null, icon: jnjInfo },
    preface: { color: null, icon: jnjInfo },
};

export const Banner: React.FunctionComponent<PropTypes> = ({
    id = "default",
    text,
    showIcon = false,
    type = "info",
    dismissText,
    dismissIcon,
    onDismiss,
    actionBtnText,
    onActionBtnClick,
    ...other
}: PropTypes) => {
    return (
        <div className={classnames(style.banner, style[type])} data-test-id={`Banner.${id}`} {...other}>
            <div className={style.text}>
                {showIcon && (
                    <span className={style.icon} data-test-id="Banner.Icon">
                        <Icon icon={mapping[type].icon} type="jnj" color={mapping[type].color} verticalAlign="middle" />
                    </span>
                )}
                <Typography data-test-id="Banner.Text" color="dark">
                    {text}
                </Typography>
            </div>
            <div className={style.buttons}>
                {onDismiss && (
                    <BannerButton type={type} onClick={onDismiss} color={mapping[type].color} testId="Dismiss">
                        {dismissIcon ? <Icon icon={mdiClose} /> : dismissText}
                    </BannerButton>
                )}
                {actionBtnText && onActionBtnClick && (
                    <BannerButton type={type} onClick={onActionBtnClick} testId="Action">
                        {actionBtnText}
                    </BannerButton>
                )}
            </div>
        </div>
    );
};
